import React from 'react';
import Box from '@mui/material/Box';

interface LoadingDotsProps {
    color?: string;
    size?: number;
    spacing?: number;
}

const LoadingDots: React.FC<LoadingDotsProps> = ({
    color = 'rgba(255, 255, 255, 0.6)',
    size = 4,
    spacing = 3
}) => {
    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: `${spacing}px`,
                py: 1
            }}
        >
            {[0, 1, 2].map((index) => (
                <Box
                    key={index}
                    sx={{
                        width: `${size}px`,
                        height: `${size}px`,
                        borderRadius: '50%',
                        backgroundColor: color,
                        animation: 'loadingDot 1.4s infinite ease-in-out both',
                        animationDelay: `${index * 0.16}s`,
                        '@keyframes loadingDot': {
                            '0%, 80%, 100%': {
                                transform: 'scale(0)',
                                opacity: 0.5
                            },
                            '40%': {
                                transform: 'scale(1)',
                                opacity: 1
                            }
                        }
                    }}
                />
            ))}
        </Box>
    );
};

export default LoadingDots;
